import { Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { InlineSvgService } from './inline-svg.service';

@Directive({ selector: '[freInlineSvg]' })
export class InlineSvgDirective implements OnDestroy {
  private inlineSvgServiceSub: Subscription;

  @Input() public set freInlineSvg(value: string | undefined | null) {
    this.inlineSvgServiceSub?.unsubscribe();
    this.insertSvg('');
    if (value) {
      this.inlineSvgServiceSub = this.inlineSvgService.getSvg(value).subscribe((data) => {
        this.insertSvg(data);
      });
    }
  }

  constructor(protected elementRef: ElementRef, private inlineSvgService: InlineSvgService) {}

  public ngOnDestroy(): void {
    this.inlineSvgServiceSub?.unsubscribe();
  }

  private insertSvg(icon: string): void {
    this.elementRef.nativeElement.innerHTML = icon;
  }
}
